const localEventNames = {
  chipsQuantity: 'chips:quantity',
  chipsPowerCost: 'chips:power-cost',
};

export default localEventNames;
